import { graphql } from "../__generated__/mcs_backend_v1";

export const INTAKE_SUBMIT_MUT = graphql(`
  mutation SubmitIntakeForm($input: IntakeSubmitInputType!) {
    intakeFormSubmit(input: $input) {
      graphqlMemberId
    }
  }
`);
